/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Type_Boolean7Inputs */

const en__field__enum_type_boolean7 = /** @type {(inputs: _Field__Enum_Type_Boolean7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boolean`)
};

/** @type {(inputs: _Field__Enum_Type_Boolean7Inputs) => LocalizedString} */
const de__field__enum_type_boolean7 = en__field__enum_type_boolean7;

/**
* | output |
* | --- |
* | "Boolean" |
*
* @param {_Field__Enum_Type_Boolean7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_type_boolean7 = /** @type {((inputs?: _Field__Enum_Type_Boolean7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Type_Boolean7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_type_boolean7(inputs)
	return de__field__enum_type_boolean7(inputs)
});
export { _field__enum_type_boolean7 as "_field__enum_type_BOOLEAN" }